<span [class]="'display-flex flex-align-center badge-status badge-status-' + status"
      [matTooltip]="tooltipMessage"
      [matTooltipDisabled]="!tooltipActivated"
      matTooltipPosition="above">
  <span *ngIf="!['import', 'create-process', 'delete-process'].includes(status)" class="badge-dot"></span>
  <mat-spinner *ngIf="['import', 'create-process', 'delete-process'].includes(status)" class="badge-spinner" [diameter]="14"></mat-spinner>
  <span class="badge-text text-ellipsis" *ngIf="status">
    {{'export.status.'+status | translate}}
  </span>
  <span class="badge-question-mark ml-5" *ngIf="tooltipActivated">
    <mat-icon [inline]="true">help</mat-icon>
  </span>
</span>
